import React from 'react'
import CookiePolicy from '../components/cookie-policy'

export default function CookiePolicyPage() {
    return <CookiePolicy />
}
